<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    v-loading="createProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Custom Destination</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="createOperation">Create</el-button>
          <el-button type="default" @click="cancelOperation">Cancel</el-button>
        </div>
      </div>
    </div>

    <el-form>
      <div class="inline-form-group">
        <el-col :span="13">
          <el-input v-model="createForm.name" placeholder="Enter name">
            <template slot="prefix">Name</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="10">
          <DadsSelect
            filterable
            v-model="createForm.ctId"
            placeholder="Select type"
            @change="onCustomTypeSelection"
          >
            <el-option
              v-for="(item, i) in customTypeOptions"
              :key="i"
              :label="item.label"
              :value="item.value"
            />
            <template slot="prefix">Type</template>
          </DadsSelect>
        </el-col>
      </div>

      <!-- FOR CUSTOM TYPE ALTERCALLERID (ct_id = 2) -->
      <div v-if="ctId === 2">
        <el-input v-model="createForm.param1" placeholder="Enter caller id name">
          <template slot="prefix">Caller id name</template>
        </el-input>
      </div>

      <!-- FOR CUSTOM TYPE CURL (ct_id = 34) -->
      <div v-if="ctId === 34">
        <h2 class="form-section-header">
          Request settings
        </h2>
        <div class="inline-form-group">
          <el-col :span="13">
            <el-input v-model="createForm.param1" placeholder="Enter URL">
              <template slot="prefix">URL</template>
            </el-input>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <el-select v-model="createForm.param2" placeholder="Select connection timeout">
              <el-option
                v-for="(n, i) in 12"
                :key="i"
                :value="n * 5"
                :label="n * 5"
              />
              <template slot="prefix">Connection timeout</template>
            </el-select>
          </el-col>
        </div>
        <el-input v-model="createForm.param3" placeholder="Enter where to store result">
          <template slot="prefix">Stored result in</template>
        </el-input>

        <el-input
          style="margin-top: 20px;"
          type="textarea"
          :rows="3"
          placeholder="Enter the post data"
          v-model="createForm.param4"
        />
      </div>

      <!-- FOR CUSTOM TYPE FORWARD (ct_id = 1) -->
      <div v-if="ctId === 1">
        <h2 class="form-section-header">
          Forward settings
        </h2>
        <div class="inline-form-group">
          <el-col :span="13">
            <el-select
              v-model="createForm.param1"
              filterable
              remote
              allow-create
              :remote-method="remoteSearchNums"
              placeholder="Enter phone number"
            >
              <el-option
                v-for="(item, i) in numOptions"
                :key="i"
                :label="item.number"
                :value="item.number"
              />
              <template slot="prefix">Phone number</template>
            </el-select>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <el-select
              v-model="createForm.param2"
              filterable
              remote
              allow-create
              :remote-method="remoteSearchCidNums"
              placeholder="Caller ID Number"
            >
              <el-option
                v-for="(item, i) in callerIdNumOptions"
                :key="i"
                :label="item.label ? item.label : item.number"
                :value="item.value ? item.value : item.number"
              />
              <template slot="prefix">Caller ID Number</template>
            </el-select>
          </el-col>
        </div>
        <div class="inline-form-group">
          <el-tag class="mb-10" type="warning">
            <i class="el-icon-warning" style="margin-right: 4px;"></i>
            Numbers should not contain special characters
          </el-tag>
        </div>
      </div>

      <!-- FOR CUSTOM TYPE PHONEBOOKLOOKUPDB (ct_id = 127) -->
      <div v-if="ctId === 127">
        <h2 class="form-section-header">
          Lookup settings
        </h2>
        <div class="inline-form-group">
          <el-col :span="13">
            <el-input v-model="createForm.param1" placeholder="Search term">
              <template slot="prefix">Search term</template>
            </el-input>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <DadsSelect v-model="createForm.param2" placeholder="Phonebook" filterable clearable>
              <el-option
                v-for="(pb, i) in phonebookOptions"
                :key="i"
                :label="pb.name"
                :value="pb.id"
              />
              <template slot="prefix">Phonebook</template>
            </DadsSelect>
          </el-col>
        </div>
        <div class="inline-form-group">
          <el-tag class="mb-10" type="primary">
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Dialplan variables can be used here
          </el-tag>
        </div>
      </div>

      <!-- FOR CUSTOM TYPE QUEUEATPOSITION (ct_id = 30) -->
      <div v-if="ctId === 30">
        <h2 class="form-section-header">
          Settings
        </h2>
        <div class="inline-form-group">
          <el-tag class="mb-10 mt-10" type="primary">
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Leave queue empty to generally apply this rule
          </el-tag>
        </div>
        <div class="inline-form-group">
          <el-col :span="13">
            <DadsSelect
              placeholder="Select queue"
              filterable
              clearable
              v-model="createForm.param1"
            >
              <el-option
                v-for="(item, i) in queueOptions"
                :key="i"
                :label="item.name"
                :value="item.id"
              />
              <template slot="prefix">Queue</template>
            </DadsSelect>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <el-select placeholder="Select queue position" v-model="createForm.param2">
              <el-option
                v-for="(n, i) in 20"
                :key="i"
                :value="n"
                :label="n"
              />
              <template slot="prefix">Queue position</template>
            </el-select>
          </el-col>
        </div>
      </div>

      <!-- FOR CUSTOM TYPE READVAR (ct_id = 24) -->
      <div v-if="ctId === 24">
        <h2 class="form-section-header">
          Variable settings
        </h2>
        <div class="inline-form-group">
          <el-col :span="13">
            <el-input v-model="createForm.param1" placeholder="Enter variable name">
              <template slot="prefix">Variable name</template>
            </el-input>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <el-select placeholder="Select max digits" v-model="createForm.param2">
              <el-option
                v-for="(n, i) in 20"
                :key="i"
                :value="n"
                :label="n"
              />
              <template slot="prefix">Max digits</template>
            </el-select>
          </el-col>
        </div>

        <div class="inline-form-group">
          <el-col :span="13">
            <el-select placeholder="Select timeout" v-model="createForm.param3">
              <el-option
                v-for="(n, i) in 24"
                :key="i"
                :label="n * 5"
                :value="n * 5"
              />
              <template slot="prefix">Timeout</template>
            </el-select>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <el-select placeholder="Select loop Count" v-model="createForm.param5">
              <el-option
                v-for="(n, i) in 10"
                :key="i"
                :value="n"
                :label="n"
              />
              <template slot="prefix">Loop count</template>
            </el-select>
          </el-col>
        </div>
        <DadsSelect v-model="createForm.param4" placeholder="Select audio message" filterable clearable>
          <el-option
            v-for="(item, i) in mediafileOptions"
            :key="i"
            :label="item.name"
            :value="item.id"
          />
          <template slot="prefix">Audio message</template>
        </DadsSelect>
      </div>

      <!-- FOR CUSTOM TYPE SETVAR (ct_id = 28) -->
      <div v-if="ctId === 28">
        <h2 class="form-section-header">
          Tag settings
        </h2>
        <div class="inline-form-group">
          <el-col :span="13">
            <el-select
              v-model="createForm.param1"
              placeholder="Select name"
            >
              <template slot="prefix">
                Tag name
              </template>
              <el-option value="tag1" label="tag1" />
            </el-select>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <el-input v-model="createForm.param2" placeholder="Tag value">
              <template slot="prefix">Tag value</template>
            </el-input>
          </el-col>
        </div>
        <div class="inline-form-group">
          <el-tag class="mb-10" type="primary">
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Dialplan variables can be used here
          </el-tag>
        </div>
      </div>

      <!-- FOR CUSTOM TYPE SEND TEXT MESSAGE (ct_id = 121)-->
      <div v-if="ctId === 121">
        <h2 class="form-section-header">
          Text message settings
        </h2>
        <div class="inline-form-group">
          <el-col :span="13">
            <el-input
              v-model="createForm.param1"
              placeholder="Enter to number"
            >
              <template slot="prefix">
                To number
              </template>
            </el-input>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <el-input
              v-model="createForm.param2"
              placeholder="Enter from number"
            >
              <template slot="prefix">
                From number
              </template>
            </el-input>
          </el-col>
        </div>
        <div class="inline-form-group">
          <el-tag class="mb-10" type="warning">
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Enter 10 digit numbers with no special characters
          </el-tag>
        </div>
        <el-input
          type="textarea"
          :autosize="{minRows: 2}"
          v-model="createForm.param3"
          placeholder="Enter message"
        />
        <div class="inline-form-group">
          <el-tag class="mb-10" type="primary">
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Dialplan variables can be used here
          </el-tag>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>

import DadsSelect from '@/components/select';

export default {
  name: "CustomDestinationCreateForm",

  props: {
    createVisible: { required: true },
    clearFormFields: { required: true },
    createProcessing: { required: true },
    queueOptions: { required: true },
    numOptions: { required: true },
    cidNumOptions: { required: true },
    mediafileOptions: { required: true },
    phonebookOptions: { required: true }
  },

  components: {
    DadsSelect
  },

  data() {
    return {
      customTypeOptions: [
        {
          label: "Alter caller id",
          value: 2
        },
        {
          label: "Forward call to",
          value: 1
        },
        {
          label: "Send a text message",
          value: 121
        },
        {
          label: "Send call to queue at position",
          value: 30
        },
        {
          label: "Read a tag",
          value: 24
        },
        {
          label: "Route by previous call",
          value: 109
        },
        {
          label: "Tag a call",
          value: 28
        }
      ],
      createForm: {
        tenantId: null,
        ctId: null,
        name: "",
        param1: "",
        param2: "",
        param3: "",
        param4: "",
        param5: "",
        param6: ""
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    ctId() {
      return this.createForm.ctId;
    },

    callerIdNumOptions() {
      return [
        ...this.cidNumOptions,
        {
          label: "Use Original",
          value: "ORIGINAL"
        },
        {
          label: "Use Incoming DID",
          value: "INCOMINGDID"
        },
        {
          label: "Use PeerId Settings",
          value: "USEPEERID"
        }
      ];
    }
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    ctId(){
      if(this.ctId === 127){
        this.createForm.param1 = this.createForm.param1 ? this.createForm.param1 : '${USR-tag1}'
      }

    },
  },

  methods: {
    remoteSearchNums(query) {
      this.$emit("remoteSearchNums", query);
    },

    remoteSearchCidNums(query) {
      this.$emit("remoteSearchCidNums", query);
    },

    onCustomTypeSelection(type) {
      this.createForm.param1 = "";
      this.createForm.param2 = "";
      this.createForm.param3 = "";
      this.createForm.param4 = "";
      this.createForm.param5 = "";
      this.createForm.param6 = "";

      if (type === 1) {
        this.createForm.param3 = "60";
        this.createForm.param6 = "LEAVEASIS";
      }
    },

    createOperation() {
      this.createForm.tenantId = this.selectedTenant.id;
      let createBody = { ...this.createForm };

/*      if(createBody.ctId === 1){
        createBody.param1 = createBody.param1.replace(/['":;/{}()[|\-.,<>?_=+ \]]/g, '')
      }*/

      for (let i = 1; i < 7; i++) {
        createBody[`param${i}`] = createBody[`param${i}`].toString();
      }
      this.$emit("createOperation", createBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "create");
    },

    clearFields() {
      this.createForm = {
        tenantId: null,
        ctId: null,
        name: "",
        param1: "",
        param2: "",
        param3: "",
        param4: "",
        param5: "",
        param6: ""
      };
    }
  },

  filters: {
    formatNumber(value) {
      return parseInt(value)
        ? `(${value.substr(0, 3)}) ${value.substr(3, 3)}-${value.substr(6, 4)}`
        : value;
    }
  }
};
</script>
